import React, { Component } from 'react';
import Login from './../../Global/Modules/Login'
import PasswordRecovery from './../../Global/Modules/PasswordRecovery'
import Subscribe from './../../Global/Modules/Subscribe'

class Account extends Component {

  render() {
    return (
      <div className="route">
        <div className="grey-bg">
          <h1 className="pageTitle">
            Welkom bij het Constructeursregister
          </h1>
          <p>Via Mijn CR krijgt u toegang tot het registratiegedeelte van de website. In het registratiegedeelte kunt u uw persoonlijke gegevens en gegevens over uw kennis en werkervaring invoeren en opvragen.</p>

          <p>Als u zich voor de eerste keer aanmeldt, voer dan uw emailadres bij Aanmelden in. U ontvangt dan automatisch een wachtwoord op uw emailadres, waarmee u de volgende keren kunt inloggen op het registratiegedeelte van de website. Wij adviseren u onder 'account' dit wachtwoord te wijzigen in een eigen wachtwoord.</p>

          <p>Aan het registreren en het beheren van uw gegevens zijn geen kosten verbonden. Uw gegevens zijn alleen zichtbaar voor u en voor het secretariaat van het Constructeursregister.</p>
        </div>
        <div className="grey-bg">
          <Login fnc={this.props.fnc} />
        </div>
        <div className="grey-bg">
          <PasswordRecovery />
        </div>
        <div className="grey-bg">
          <Subscribe />
        </div>
      </div>
    );
  }
}

export default Account;



// WEBPACK FOOTER //
// ./src/components/Public/Pages/Account.js